import './TableOrders.css'

import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import { FixedSizeList as List } from 'react-window'
import useSyncScroll from 'utils/useSyncScroll'

import TableOrdersHeader from './TableOrdersHeader'
import TableOrdersRow from './TableOrdersRow'

const TableOrders = ({
  headerClassName,
  itemHeight,
  listHeight,
  maxOrdersValue,
  onFilter,
  onScroll,
  scrollOffset,
  showModal,
  sortBy,
  stores,
  totalOrders,
  totalOrdersValue,
  type,
}) => {
  const listRef = useRef()

  useSyncScroll(listRef, scrollOffset)

  return (
    <div className="table-orders">
      <TableOrdersHeader className={headerClassName} onFilter={onFilter} sortBy={sortBy} type={type} />

      <List
        useIsScrolling
        className="table-orders-row"
        height={listHeight}
        itemCount={stores.length}
        itemData={{
          maxOrdersValue,
          showModal,
          stores,
          totalOrders,
          totalOrdersValue,
          type,
        }}
        itemSize={itemHeight}
        onScroll={onScroll}
        overscanCount={8}
        ref={listRef}
        width="100%"
      >
        {TableOrdersRow}
      </List>
    </div>
  )
}

TableOrders.propTypes = {
  headerClassName: PropTypes.string,
  itemHeight: PropTypes.number,
  listHeight: PropTypes.number,
  maxOrdersValue: PropTypes.number,
  onFilter: PropTypes.func,
  onScroll: PropTypes.func,
  scrollOffset: PropTypes.number,
  showModal: PropTypes.func,
  sortBy: PropTypes.object,
  stores: PropTypes.array,
  totalOrders: PropTypes.number,
  totalOrdersValue: PropTypes.number,
  type: PropTypes.string,
}

export default TableOrders
